// @ts-nocheck
import { connectPagination, Pagination } from 'react-instantsearch-dom';

export const PaginationControls = connectPagination(({ nbPages }) => nbPages > 1 && <Pagination />);
